module.exports = __webpack_public_path__ + "startpage-be63061f/template-1-preview-78faf19c2fc1b3c1ee6790e6dcd0ebdb.jpg";